<template>
  <div class="select_dialog_embed">
    <div class="user_settings_embed_msg">
      <div class="select_dialog_embed_box" :class="{'select_dialog_embed_box_490': showType === 'removeBinding'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--新增用户-->
          <div v-if="showType === 'addUser'" class="select_dialog_embed_box_handle">
            <div>
              <label><i class="fcDel">*</i>登录账号：</label>
              <input type="text" title="登录账号" maxlength="36" v-model="addNum">
            </div>
            <div>
              <label><i class="fcDel">*</i>姓名：</label>
              <input type="text" title="姓名" maxlength="50" v-model="addModifyName">
            </div>
            <div>
              <label><i class="fcDel">*</i>联系电话：</label>
              <input type="text" title="联系电话" v-model="addModifyTel">
            </div>
            <div>
              <label><i class="fcDel">*</i>所属角色：</label>
              <div class="inb w_percent70">
                <el-select class="w_percent100" v-model="selectRole" placeholder="请选择">
                  <el-option
                    v-for="item in allRoles"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <!--编辑用户-->
          <div v-if="showType === 'modifyUser'" class="select_dialog_embed_box_handle">
            <div>
              <label><i class="fcDel">*</i>姓名：</label>
              <input type="text" title="姓名" maxlength="50" v-model="addModifyName">
            </div>
            <div>
              <label><i class="fcDel">*</i>联系电话：</label>
              <input type="text" title="联系电话" v-model="addModifyTel">
            </div>
            <div>
              <label><i class="fcDel">*</i>所属角色：</label>
              <div class="inb w_percent70">
                <el-select class="w_percent100" v-model="selectRole" placeholder="请选择">
                  <el-option
                    v-for="item in allRoles"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <!--QQ客服-->
          <div v-if="showType === 'QQNum'">
            <div class="w250 mauto">
              <input class="text_center mt30 mb30" type="text" v-model.trim="QQNum" maxlength="20">
            </div>
          </div>

          <!--重置密码-->
          <div v-if="showType === 'resetPwd'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要重置密码，重置后的密码为“<span class="warn">sdkj123456</span>”！
            </div>
          </div>

          <!--删除用户-->
          <div v-if="showType === 'delUser'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要删除当前用户，删除后数据将不可进行恢复！
            </div>
          </div>

          <!--停用用户-->
          <div v-if="showType === 'disableUser'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要停用当前用户，停用后用户将禁止登录！
            </div>
          </div>

          <!--启用用户-->
          <div v-if="showType === 'enableUser'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要启用当前用户，启用后用户可进行正常登录！
            </div>
          </div>

        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_normal" @click="submitBtn()">提交</button>
          <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'user-settings-embed-msg',
    /**
     *  showType: addUser=新增用户  modifyUser=编辑用户  enableUser=启用用户  disableUser=停用用户  resetPwd=重置密码  delUser=删除用户
     *  userMsg: 用户信息
     * */
    props: ['title', 'showType', 'userMsg'],
    components: {MsgDialog},
    data() {
      return {
        addNum: '', // 新增登录账号
        addModifyName: '', // 新增姓名
        addModifyTel: '', // 新增联系电话
        allRoles: [], // 所有角色下拉选项
        selectRole: '', // 选择的角色
        QQNum: '', // 客服QQ
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 接受每个组件传送过来的数据
      componentsCancel() {
        this.cancelBtn(null);
      },

      // 获取当前分销商的所有角色——下拉框的
      getClientRoleData() {
        this.$axios.get(this.Global.getClientRoleData).then((res) => {
          if (!res.data.errorMsg.length) {
            for (let i = 0; i < res.data.resData.length; i++) {
              this.allRoles.push({Id: res.data.resData[i].Id, Name: res.data.resData[i].Name});
            }
            this.allRoles.splice(0, 0, {Id: '', Name: '所有角色'});
            // console.log(this.allRoles);
            // this.selectRole = '';
          } else {
            alert(res.data.errorMsg);
          }
        });
      },

      // 新增用户
      addUserNum() {
        if (!this.addNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入登录账号';
        } else if (!this.addModifyName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入姓名';
        } else if (!this.addModifyTel) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入联系电话';
        } else if (!this.phoneCheck(this.addModifyTel)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入正确的联系电话';
        } else if (this.selectRole === '') {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择角色';
        } else {
          // this.cancelBtn(null);
          const params = {
            loginName: this.addNum,
            userName: this.addModifyName,
            phone: this.addModifyTel,
            roleId: this.selectRole
          };
          this.$axios.post(this.Global.saveUser, params).then((res) => {
            console.log(res);
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        }
      },

      // 编辑用户
      modifyUserNum() {
        if (!this.addModifyName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入姓名';
        } else if (!this.addModifyTel) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入联系电话';
        } else if (!this.phoneCheck(this.addModifyTel)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入正确的联系电话';
        } else if (this.selectRole === '') {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择角色';
        } else {
          const params = {
            loginName: this.userMsg.LoginName,
            userId: this.userMsg.Id,
            userName: this.addModifyName,
            phone: this.addModifyTel,
            roleId: this.selectRole
          };
          this.$axios.post(this.Global.saveUser, params).then((res) => {
            console.log(res);
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        }
      },

      // 重置密码
      resetPwd() {
        this.$axios.get(this.Global.resetPwd(this.userMsg.Id)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 修改用户状态
      changeStatus() {
        let status;
        if (this.showType === 'enableUser') {
          status = 1;
        } else if (this.showType === 'disableUser') {
          status = 2;
        }
        this.$axios.get(this.Global.changeStatus(this.userMsg.Id, status)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 删除用户
      deleteUser() {
        this.$axios.get(this.Global.deleteUser(this.userMsg.Id)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 获取当前分销商的QQ
      getProxyQQ() {
        this.$axios.get(this.Global.getProxyQQ).then((res) => {
          if (!res.data.errorMsg.length) {
            // this.cancelBtn(true);
            console.log(res);
            this.QQNum = res.data.resData;
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 保存分销商QQ
      saveProxyQQ() {
        if (this.QQcheck()) {
          this.$axios.post(this.Global.saveProxyQQ(this.QQNum), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        } else {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写正确的qq号';
        }
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'addUser') { // 新增用户
          this.addUserNum();
        } else if (this.showType === 'modifyUser') { // 编辑用户
          this.modifyUserNum();
        } else if (this.showType === 'QQNum') { // 设置客服QQ
          this.saveProxyQQ();
          // this.QQcheck();
        } else if (this.showType === 'delUser') { // 删除用户
          this.deleteUser();
        } else if (this.showType === 'resetPwd') { // 重置密码
          this.resetPwd();
        } else { // 修改用户状态
          this.changeStatus();
        }

        // 计时器
        this.time = 3;
        const self = this;
        this.timer = setInterval(function () {
          self.time = --self.time;
          if (self.time < 1) {
            self.isMsg = false;
            clearInterval(self.timer);
          }
        }, 1000);
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 手机号正则表达式
      phoneCheck (num) {
        // /^1(3|4|5|7|8)\d{9}$/
        const reg = /^[1][0-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
        // const reg = /^1([34578])\d{9}$/;
        return reg.test(num);
      },

      // QQ正则表达式 1.首位不能是0  ^[1-9]   2.必须是 [5, 11] 位的数字  \d{4, 9}
      /**
       * @return {boolean}
       */
      QQcheck() {
        const reg = /^[1-9][0-9]{4,9}$/g;
        return reg.test(this.QQNum);
      }
    },
    created() {
      this.getClientRoleData();
      if (this.userMsg) {
        this.addModifyName = this.userMsg.UserName;
        this.addModifyTel = this.userMsg.Tel;
        this.selectRole = this.userMsg.RoleId;
      }
      if (this.showType === 'QQNum') {
        this.getProxyQQ();
      }
    },
    destroyed() {
      // 离开页面配置路由
      console.log('我离开页面了！');
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .select_dialog_embed {
    .user_settings_embed_msg {
      .select_dialog_embed_box .select_dialog_embed_box_content .select_dialog_embed_box_handle > div {
        input[type='text'] {
          width: 64%;
        }

        label {
          width: 78px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/user-settings-embed-msg.vue